export enum DialogResult {
  OK = 1,
  Cancel,
  Abort,
  Retry,
  Ignore,
  Yes,
  No,
}

export enum MessageMode {
  None = 1,
  Info,
  Question,
  Warning,
  Error,
}

export namespace MessageMode {
  export function GetValues() {
    let object: { [key: string]: MessageMode } = {
      None: MessageMode.None,
      Info: MessageMode.Info,
      Question: MessageMode.Question,
      Warning: MessageMode.Warning,
      Error: MessageMode.Error,
    };

    return object;
  }
}

export enum MessageBoxButtons {
  OK = 1,
  OKCancel,
  AbortRetryIgnore,
  YesNoCancel,
  YesIgnoreCancel,
  YesNo,
  RetryCancel,
}

export namespace MessageBoxButtons {
  export function GetValues() {
    let object: { [key: string]: MessageBoxButtons } = {
      OK: MessageBoxButtons.OK,
      OKCancel: MessageBoxButtons.OKCancel,
      AbortRetryIgnore: MessageBoxButtons.AbortRetryIgnore,
      YesNoCancel: MessageBoxButtons.YesNoCancel,
      YesIgnoreCancel: MessageBoxButtons.YesIgnoreCancel,
      YesNo: MessageBoxButtons.YesNo,
      RetryCancel: MessageBoxButtons.RetryCancel,
    };

    return object;
  }
}

export enum MessageBoxIcon {
  None = '',
  Info = 'assets/images/attention.svg',
  Question = 'assets/images/question.svg',
  Warning = 'assets/images/warning.svg',
  Error = 'assets/images/error.svg',
}

export namespace MessageBoxIcon {
  export function GetValues() {
    let object: { [key: string]: MessageBoxIcon } = {
      None: MessageBoxIcon.None,
      Info: MessageBoxIcon.Info,
      Question: MessageBoxIcon.Question,
      Warning: MessageBoxIcon.Warning,
      Error: MessageBoxIcon.Error,
    };

    return object;
  }
}
